import { CookieSerializeOptions } from 'cookie';

export const PROVIDER_ID_COOKIE = 'providerId';
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;
export const SURVEY_COOKIE = 'completedSurveys';

// @todo вынести на уровень инициализации контекста, заменить maxAge для common
export const SURVEY_COOKIE_CONFIG: CookieSerializeOptions = {
    domain: COOKIE_DOMAIN,
    path: '/',
    maxAge: 30 * 24 * 60 * 60,
};

export const BECOME_CLIENT_SURVEY = 'become-client-header-button-survey';
